export function viewportHeight() {
    function update() {
        document.documentElement.style.setProperty('--real-vh', `${window.innerHeight}px`);
        document.documentElement.style.setProperty('--real-vw', `${document.body.clientWidth}px`);
    }
    window.addEventListener('resize', update);
    update();
}
